
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[article]",
      function () {
        return require("private-next-pages/education/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[article]"])
      });
    }
  